// extracted by mini-css-extract-plugin
module.exports = {"col":"_3xtFnpdY","questionContainer":"_2tADgBtz","question":"txxXXziY","questionTitle":"_1I1VEyJw","questionText":"_22ogcXQk"};